import React, { useState, useEffect } from "react";
import md5 from "md5";
import qs from "qs";
import axios from "axios";
import Config from "../../util/config";
import Minus from "../../assets/minus.svg";
import Plus from "../../assets/plus.svg";
import "./accordion.css";


const API_BASE = "https://api2.giftcard8.com";
// const API_BASE = "https://test-giftcard8-api.gcard8.com";

const Accordion = () => {
  const [data1, setData1] = useState([]);
  const [data2, setData2] = useState([]);
  const [activeSection, setActiveSection] = useState(null);
  const [activeIndex, setActiveIndex] = useState(null);

  useEffect(() => {
    async function FaqData(appid) {
      if (!appid) {
        throw new Error("All parameters must be provided");
      }

      const categoryParams = {
        appid: appid,
      };
      const categoryPayload = {
        ...categoryParams,
        sign: md5(
          qs.stringify(categoryParams, { arrayFormat: "indices", encode: false }) +
            Config.appKey
        ),
      };

      const listParams = {
        appid: appid,
        page_size: 100,
      };
      const listPayload = {
        ...listParams,
        sign: md5(
          qs.stringify(listParams, { arrayFormat: "indices", encode: false }) +
            Config.appKey
        ),
      };
      
      try {

        const response1 = await axios.post(
          `${API_BASE}/gc/faq/categories`,
          qs.stringify(categoryPayload),
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded"
            }
          }
        );
        const response2 = await axios.post(
          `${API_BASE}/gc/faq/list`,
          qs.stringify(listPayload),
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        );

        const responseOne = response1.data.data;
        const responseTwo = response2.data.data 

        setData1( responseOne || []);
        setData2( responseTwo || []);

        if (responseOne.length > 0) {
          setActiveSection(responseOne[0]); 
        }

      } catch (error) {
        throw error;
      }
    }

    FaqData("web-v1").catch((error) => console.error("Error:", error));
  }, []);

  const renderContent = (content) => {
    if (!content) return null;
  
    if (typeof content === "string") {
      const parser = new DOMParser();
      const doc = parser.parseFromString(content, "text/html");
  
      const elements = doc.querySelectorAll("*"); 
  
      elements.forEach((element) => {
        element.style.fontFamily = "Open Sans";
        element.style.fontSize = "14px";
      });
  
      return <div dangerouslySetInnerHTML={{ __html: doc.body.innerHTML }} />;
    }
  
    return null;
  };
  
   

  const toggleItem = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const groupedData = data1.reduce((acc, category) => {
    acc[category] = data2.filter((item) => item.category_name === category);
    
    return acc;
  }, {});

  const sortedCategories = Object.keys(groupedData);



  return (
    <div className="accordion-container">
      <nav className="accordion-navigation">
        {sortedCategories.map((category) => (
          <button
            key={category}
            className={`accordion-nav-item b-0 ${
              activeSection === category ? "active" : ""
            }`}
            onClick={() => {
              setActiveSection(category);
              setActiveIndex(null);
            }} 
          >
            {category}
          </button>
          
        ))}
        
      </nav>

      <div className="accordion">
        {groupedData[activeSection]?.map((item, index) => (
          
          <div key={item.id} className="accordion-item">
            <div
              className={`accordion-header ${
                activeIndex === index ? "active" : ""
              }`}
              onClick={() => toggleItem(index)}
            >
              <span>{item.question}</span>
              <span className="accordion-icon">
                {activeIndex === index ? (
                  <img src={Minus} alt="Collapse" />
                ) : (
                  <img src={Plus} alt="Expand" />
                )}
              </span>
            </div>
            <div
              className={`accordion-body ${
                activeIndex === index ? "px-0 open" : ""
              }`}
            >
                <div>{renderContent(item.answer)}</div>
            </div>
          </div>
        ))}
      </div>

    </div>
  );
};

export default Accordion;
